function SubMenu({ subMenus = [], selectedSubMenu, setSelectedSubMenu }) {
  return (
    <div className="sub-menu">
      { subMenus.map((subMenu) => {
        return <span className={selectedSubMenu === subMenu && 'active'}>{subMenu}</span>
      })}
    </div>
  );
}

export default SubMenu;
